const passwordStrength = (password) => password?.length >= 6
  && (/[a-z]/.test(password))
  && (/[A-Z]/.test(password))
  && (/[0-9]/.test(password));

export {
  // eslint-disable-next-line import/prefer-default-export
  passwordStrength,
};
